import { render, staticRenderFns } from "./AdminUserRoute.vue?vue&type=template&id=112109f0"
import script from "./AdminUserRoute.vue?vue&type=script&lang=js"
export * from "./AdminUserRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports